import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface WarningsData {
    warnings: { name: string; modules: string[] }[];
    isFile?: boolean;
}

@Component({
    selector: 'used-images-modal',
    templateUrl: 'used-images-modal.component.html',
    styleUrls: ['used-images-modal.component.scss'],
})
export class UsedImagesModalComponent {
    constructor(
        public dialogRef: MatDialogRef<UsedImagesModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WarningsData
    ) {
        console.log('DATOS MODAL WARNING >>> ', data);
    }

    closeDialog(userConfirm?: boolean): void {
        this.dialogRef.close(userConfirm);
    }
}
